import { render } from "./Yousejinshu.vue?vue&type=template&id=27c38046&scoped=true"
import script from "./Yousejinshu.vue?vue&type=script&lang=js"
export * from "./Yousejinshu.vue?vue&type=script&lang=js"

import "./Yousejinshu.vue?vue&type=style&index=0&id=27c38046&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c38046"]])

export default __exports__